import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=edb8e022&scoped=true"
import script from "./FilterCard.vue?vue&type=script&lang=js"
export * from "./FilterCard.vue?vue&type=script&lang=js"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=edb8e022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb8e022",
  null
  
)

export default component.exports